<template>
  <div class="my-dropdown-wrapper">
    <VaDropdown v-model="isShown" :offset="[9, 0]" class="my-dropdown" stick-to-edges>
      <template #anchor>
        <VaButton preset="secondary" color="textInverted">
          <span class="my-dropdown__anchor min-w-max">
            <slot />
            <div>{{ t('menu.programs') }}</div>
          </span>
        </VaButton>
      </template>
      <VaDropdownContent class="my-dropdown__content md:w-60 px-0 py-4 w-full" :style="{ '--hover-color': hoverColor }">
        <VaListItem
          v-for="option in options"
          :key="option.name"
          class="menu-item px-4 text-base cursor-pointer h-8"
          :to="option.to"
        >
          {{ t(option.name) }}
        </VaListItem>
      </VaDropdownContent>
    </VaDropdown>
  </div>
</template>

<script lang="ts" setup>
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useColors } from 'vuestic-ui'

const { colors, setHSLAColor } = useColors()
const hoverColor = computed(() => setHSLAColor(colors.focus, { a: 0.1 }))

const { t } = useI18n()

type OptionItem = {
  name: string
  to: Record<string, any>
}

withDefaults(
  defineProps<{
    options?: OptionItem[]
  }>(),
  {
    options: () => [
      {
        name: 'menu.residency',
        to: { name: 'programs', query: { query: 'residency' } },
      },
      {
        name: 'menu.citizenship',
        to: { name: 'programs', query: { query: 'citizenship' } },
      },
    ],
  },
)

const isShown = ref(false)
</script>

<style lang="scss" scoped>
.my-dropdown {
  cursor: pointer;

  &__anchor {
    display: inline-block;
  }

  &__content {
    background: #064e8a !important;
    border-radius: 8px;
    .menu-item {
      transition: background 0.15s ease;
      color: #fff;
      &:hover {
        background-color: var(--hover-color);
      }
    }
  }
}
</style>
